// Figma widths (px) - adjusted for company drawer context
export const WIDTH_ALERT = 400
export const WIDTH_SEVERITY = 120
export const WIDTH_STATUS = 160
export const WIDTH_DATE_DETECTED = 140
